module.exports = __webpack_public_path__ + "img/xm2.1e1ce4b3.png";